import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import userReducer from './slices/userSlice';
import settingReducer from './slices/settingSlice';
import branchReducer from './slices/branchSlice';
import appointmentReducer from './slices/appointmentSlice';
import consultationReducer from './slices/consultationSlice';
import paymentReducer from './slices/paymentSlice';
import commonReducer from './slices/commonSlice';
import procedureReducer from './slices/procedureSlice';
import packageReducer from './slices/packageSlice';
import sessionReducer from './slices/sessionSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    setting:settingReducer,
    branch:branchReducer,
    appointment:appointmentReducer,
    consultation:consultationReducer,
    payment:paymentReducer,
    common:commonReducer,
    procedure:procedureReducer,
    package:packageReducer,
    session:sessionReducer,
  },
});

// Infer the `RootState` type from the store itself
export type RootState = ReturnType<typeof store.getState>;

// Optionally, define `AppDispatch` type if needed
export type AppDispatch = typeof store.dispatch;

export default store;
